
import { mapState } from 'vuex'
import SidebarItem from './SidebarItem'
import { fileNameVerify, getFileName } from '~/utils/common'

export default {
  name: 'Sidebar',
  components: { SidebarItem },
  data() {
    return {
      newFolderShow: false,
      newFolder: {
        name: '新建文件夹',
        path: '/',
        owner: '',
      },
      tooltipShow: false,
      modelText: '',
      isUpload: false,
    }
  },
  computed: {
    ...mapState(['routers']),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
  },
  directives: {
    'click-outside': {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
  },
  methods: {
    /**
     * 新建按钮
     */
    handleFolder() {
      let path = this.$route.path
      let query = this.$route.query
      let data = {}
      if (path.includes('/resource/folder/')) {
        path = this.$route.path.split('/')
        path = decodeURIComponent(path[path.length - 1])
      } else {
        path = '/'
      }
      data.path = path
      if (query.owner) {
        data.owner = query.owner
      }
      this.$javaApi.getFolderTree(data).then((res) => {
        if (res.code === 200) {
          this.modelText = ''
          this.newFolder = {
            name: getFileName(res.data),
            path,
            owner: res.data.owner,
          }
          this.newFolderShow = true
        }
      })
    },
    updateFolder(data) {
      this.newFolder.owner = data.owner
    },
    /**
     * 新建文件夹
     */
    handleNewFolder() {
      let verify = fileNameVerify(this.newFolder.name)
      if (verify) {
        this.modelText = verify
        return
      }
      this.newFolderShow = false
      this.$bus.$emit('showLoading')
      this.$javaApi.mkdirFolder(this.newFolder).then((res) => {
        this.$bus.$emit('hideLoading')
        if (res.code === 200) {
          this.$modal.msgSuccess('新建成功')
          this.$bus.$emit('refreshFolder')
        } else {
          this.tooltipShow = true
          this.modelText = '相同文件夹或文件已存在'
        }
      })
    },
    /**
     * 上传按钮
     */
    handleUpload() {
      this.isUpload = !this.isUpload
    },
    /**
     * 关闭
     */
    closeDropdown() {
      this.isUpload = false
    },
    /**
     * 上传文件
     */
    handleUploadActive(type) {
      this.closeDropdown()
      this.$bus.$emit('showUpload', type)
    },
  },
}
